import { createAction, props } from '@ngrx/store';

import { GuaranteeApplication, GuaranteeApplicationSearchModel } from '@lib/core/models/guarantee-application.interface';
import { PagedResponse } from '@lib/core/models/paged-response';
import {
  GenericServiceValue,
  PersonalDoctorValue,
  PharmacologicalTreatmentValue,
  Prescription,
  PrescriptionFormValue,
  PrescriptionTypes,
} from '@lib/core/models/prescription.interface';
import { Visit } from '@lib/core/models/visit.interface';

export const savePrescription = createAction('[Prescriptions Page] Save prescription');
export const editPrescription = createAction('[Prescriptions Page] Edit prescription', props<{ editData: Prescription }>());
export const deletePrescription = createAction('[Prescriptions Page] Delete prescription', props<{ deletionData: { id: string; type: PrescriptionTypes } | null }>());

export const setPrescriptionsInitRequired = createAction('[Prescriptions Page] Set init required', props<{ initRequired: boolean }>());
export const setPrescriptionsSearchFilter = createAction('[Prescriptions List] Set search filter', props<{ search: string }>());

export const setPrescriptionsPage = createAction('[Prescriptions List] Set guarantees page', props<{ page: number }>());
export const incrementPrescriptionsPage = createAction('[Prescriptions List] Increment page');

export const fetchPrescriptions = createAction('[Prescriptions List] Fetch all guarantees', props<Partial<GuaranteeApplicationSearchModel>>());
export const fetchPrescriptionsSuccess = createAction('[Prescriptions List] Fetch all guarantees success', props<{ pagedResponse: PagedResponse<GuaranteeApplication> }>());
export const fetchPrescriptionsFailure = createAction('[Prescriptions List] Fetch all guarantees failure', props<{ error: string }>());

export const loadPrescriptionDraftsFromStorage = createAction(
  '[Prescriptions Store] Load prescription drafts from storage',
  props<{ drafts: PrescriptionFormValue<PharmacologicalTreatmentValue | GenericServiceValue | PersonalDoctorValue>[] }>()
);
export const addPrescriptionDraft = createAction(
  '[Prescriptions Page] Add prescription draft',
  props<{ draft: PrescriptionFormValue<PharmacologicalTreatmentValue | GenericServiceValue | PersonalDoctorValue> }>()
);
export const updatePrescriptionDraft = createAction(
  '[Prescriptions Page] Update prescription draft',
  props<{ draft: PrescriptionFormValue<PharmacologicalTreatmentValue | GenericServiceValue | PersonalDoctorValue> }>()
);
export const deletePrescriptionDraft = createAction('[Prescriptions Page] Delete prescription draft', props<{ id: string }>());
export const processPrescriptionsDrafts = createAction('[Prescriptions Page] Process prescription drafts', props<{ memberId: string }>());
export const processPrescriptionsDraftsSuccess = createAction('[Prescriptions Page] Process prescription drafts success');
export const processPrescriptionsDraftsFailure = createAction('[Prescriptions Page] Process prescription drafts failure', props<{ error: string }>());

export const clearPrescriptions = createAction('[Prescriptions List] Clear prescriptions');
export const resetPrescriptionsState = createAction('[Prescriptions List] Clear prescriptions state');

export const openAppointmentDetailsDialog = createAction('[Prescription Item] Open prescription details dialog', props<{ prescription: Prescription; appointments: Visit[] }>());
export const closeAppointmentDetailsDialog = createAction('[Prescription Item] Close prescription details dialog');

export const openAppointmentCreationDialog = createAction('[Prescription Item] Open appointment creation dialog', props<{ action: Visit }>());
export const closeAppointmentCreationDialog = createAction('[Prescription Item] Close appointment creation dialog');

export const openAppointmentEditDialog = createAction('[Prescription Item] Open appointment edit dialog', props<{ appointment: Visit }>());
export const closeAppointmentEditDialog = createAction('[Prescription Item] Close appointment edit dialog');

export const openAppointmentCancellationDialog = createAction('[Prescription Item] Open appointment cancellation dialog', props<{ appointment: Visit }>());
export const closeAppointmentCancellationDialog = createAction('[Prescription Item] Close appointment cancellation dialog');
